import axios from "axios";
import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import Reports from "./reports";
import Activities from "./activities";
import ManualPayouts from "./manual-payouts";
import './style.scss';

const Dashboard = () => {
    const { addToast } = useToasts();
    const [activities, setActivities] = useState([]);
    const [isFetchingActivities, setIsFetchingActivities] = useState(false);
    const [hasMoreActivities, setHasMoreActivities] = useState(true);
    const [reports, setReports] = useState({
        posts: 0,
        users: 0,
        subscribers: 0,
        creators: 0
    })

    useEffect(() => {
        getReports();
        getActivities();
    }, []);

    const getReports = () => {
        axios.get('/api/administration/reports')
        .then(res => {
            const reportsData = res.data;
            setReports(reportsData);
        })
        .catch(err => {
            console.log(err.response)
            addToast('Unable to get reports!', { appearance: 'error', autoDismiss: true });
        })
    }

    const getActivities = () => {
        setIsFetchingActivities(true);
        axios.get(`/api/administration/activities/recent?skip=${activities.length}`)
        .then(res => {
            const data = res.data.posts;
            setActivities([...activities, ...data]);
            setIsFetchingActivities(false);
            setHasMoreActivities(res.data.has_more);
        })
        .catch(err => {
            console.log(err.response)
            addToast('Unable to get activities!', { appearance: 'error', autoDismiss: true });
            setIsFetchingActivities(false);
        })
    }

  return (
    <div>
        <h3 className="mb-4">Dashboard</h3>
        <Reports reports={reports}/>
        <ManualPayouts/>
        <Activities activities={activities} getActivities={getActivities} isLoading={isFetchingActivities} />
    </div>
  )
}

export default Dashboard;
